import { useHotkey as useTanstackHotkey } from "@tanstack/react-hotkeys";
import { useMDSHotkeyContext } from "./mds-hotkey-context";
import type { HotkeyCallback, RegisterableHotkey, UseHotkeyOptions } from "@tanstack/react-hotkeys";

export type { HotkeyOptions, UseHotkeyOptions } from "@tanstack/react-hotkeys";

export const useMDSHotKey = (
  hotkey: RegisterableHotkey,
  callback: HotkeyCallback,
  options?: UseHotkeyOptions
): void => {
  const { onKeyboardEvent } = useMDSHotkeyContext();

  useTanstackHotkey(
    hotkey,
    (event, context) => {
      const shortcut = context?.hotkey ?? String(hotkey);

      try {
        onKeyboardEvent?.({ shortcut });
      } catch {
        // Instrumentation should never block shortcut handling.
      }

      return callback(event, context);
    },
    options
  );
};
